import React from "react"
import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@carrotfertility/carotene-core"
import { DialogCloseButton } from "@carrotfertility/carotene-core-x"

export interface AccessOriginAccountDialogProps {
  open: boolean
  onClose: () => void
}

export function AccessOriginAccountDialog({ open, onClose }: AccessOriginAccountDialogProps): JSX.Element {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogCloseButton onClick={onClose} />
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <DialogTitle>Activate Origin account</DialogTitle>
      <DialogContent>
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        <DialogContentText>
          This is a placeholder for the Origin account dialog flow. The actual flow will be implemented in a follow-up.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}
